import React from 'react';
import Modal from '@dealroadshow/uikit-modal';
import PhysicalCopyForm from './PhysicalCopyForm';
import { useSessionContext } from '@users/session/SessionContext';
import { IPhysicalCopyDataroom } from './IPhysicalCopyDataroom';
import PhysicalDeliveryProvider from '../../contexts/PhysicalDeliveryContext';

interface IProps {
  dataroom: IPhysicalCopyDataroom,
  onClose: () => void,
}

const PhysicalCopyModal = ({
  dataroom,
  onClose,
}: IProps) => {
  const { currentUser } = useSessionContext();

  return (
    <Modal
      onCloseClicked={ onClose }
      isVisible
      dataTest="dataroomPhysicalCopyModal"
    >
      <PhysicalCopyForm
        dataroom={ dataroom }
        onClose={ onClose }
        currentUser={ currentUser }
      />
    </Modal>
  );
};

export default (props: React.ComponentProps<typeof PhysicalCopyModal>) => (
  <PhysicalDeliveryProvider>
    <PhysicalCopyModal { ...props } />
  </PhysicalDeliveryProvider>
);
